var faker = require('./../../_js-common-modules').faker;

(function(){
    $('[data-faker]').each(function(){
        var $element = $(this);
        var fakerCommand = $element.data('faker');

        fakerCommand = fakerCommand.replace(/\[\[/g, '{{').replace(/\]\]/g, '}}');

        var data = faker.fake(fakerCommand);

        if($element.prop('tagName') == 'IMG'){
            $element.prop('src', data);
        }else{
            $element.text(data);
        }
    });
})();
